// extracted by mini-css-extract-plugin
module.exports = {"default":"Rule_default__1Yt5y"};